import { render } from "./readMoreClients.vue?vue&type=template&id=91d21ffa&scoped=true&ts=true"
import script from "./readMoreClients.vue?vue&type=script&lang=ts"
export * from "./readMoreClients.vue?vue&type=script&lang=ts"

import "./readMoreClients.vue?vue&type=style&index=0&id=91d21ffa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-91d21ffa"]])

export default __exports__